import cx from 'classnames'
import { forwardRef } from 'react'
import Styles from './InsertButton.module.scss'

type InsertButtonProps = {
  icon: React.ReactNode
  label: string
  onClick?: (event: React.MouseEvent<HTMLElement>) => void
  disabled?: boolean
  inDropdown?: boolean
  isSubmenu?: boolean
  children?: React.ReactNode
  rightContent?: React.ReactNode
  mouseEnter?: (event: React.MouseEvent<HTMLElement>) => void
  mouseLeave?: (event: React.MouseEvent<HTMLElement>) => void
}
export const InsertButton = forwardRef<HTMLButtonElement, InsertButtonProps>(
  ({ icon, label, onClick, disabled, children, mouseLeave, mouseEnter, inDropdown, isSubmenu, rightContent }, ref) => {
    return (
      <div
        className={cx(Styles.buttonContainer, { [Styles.inDropdown]: inDropdown, [Styles.isSubmenu]: isSubmenu })}
        onMouseEnter={(event) => {
          if (mouseEnter) mouseEnter(event)
        }}
        onMouseLeave={(event) => {
          if (mouseLeave) {
            setTimeout(() => {
              mouseLeave(event)
            }, 400)
          }
        }}
      >
        <button
          className={cx(Styles.button, { [Styles.disabled]: disabled })}
          onClick={onClick}
          ref={ref}
          disabled={disabled}
        >
          {icon}
          <div className={Styles.label}>{label}</div>
          {rightContent && <div className={Styles.rightContent}>{rightContent}</div>}
        </button>
        {children}
      </div>
    )
  },
)
